function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38 38"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "19",
  cy: "19",
  r: "19",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE7C22",
  fillRule: "nonzero",
  d: "M20.59 12.813c.4 0 .736-.148 1.006-.443.27-.295.404-.64.404-1.037a1.29 1.29 0 00-.393-.932c-.263-.267-.602-.401-1.017-.401-.371 0-.692.142-.962.427-.27.285-.404.618-.404 1 0 .361.135.682.404.964.27.28.59.421.962.421zM18.426 26c.284 0 .627-.05 1.028-.151.4-.1.936-.28 1.606-.537l.164-.666c-.138.048-.337.09-.596.125a4.759 4.759 0 01-.595.052c-.416 0-.716-.073-.902-.219-.186-.146-.279-.416-.279-.812 0-.167.028-.38.082-.641.055-.26.119-.526.192-.797l1.17-4.427a5.24 5.24 0 00.174-1.156c0-.459-.135-.823-.404-1.094-.27-.27-.704-.406-1.301-.406-.262 0-.62.059-1.071.177-.452.118-.962.299-1.53.542l-.164.666c.138-.034.34-.076.607-.125.265-.048.479-.073.639-.073.415 0 .69.065.825.193.135.129.202.387.202.776 0 .195-.027.43-.082.708-.054.278-.11.539-.17.782l-1.158 4.427a9.198 9.198 0 00-.142.656c-.029.174-.043.34-.043.5 0 .424.145.78.437 1.068.291.288.728.432 1.311.432z"
}))));